(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-category-rails"]) return;
  try {
    
  /*
   * Raylar görünme noktasına gelince yükleniyor. Marka sayfasında beş ray olabiliyor
   * ve hepsini açılışta çekmek, ziyaretçinin hiç kaydırmayacağı içerik için beş istek
   * demek. `IntersectionObserver` bunu ziyaretçinin gerçekten baktığı raylara indiriyor.
   */
  class BrandCategoryRails extends HTMLElement {
    connectedCallback() {
      this.itemsSectionId = document.getElementById('nm-rail-items')?.dataset.sectionId;
      if (!this.itemsSectionId) return;

      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            observer.unobserve(entry.target);
            this.load(entry.target);
          }
        },
        { rootMargin: '400px 0px' },
      );

      for (const rail of this.querySelectorAll('.nm-rail')) observer.observe(rail);
    }

    async load(rail) {
      const track = rail.querySelector('.nm-rail__track');
      try {
        const response = await fetch(`${rail.dataset.url}&section_id=${this.itemsSectionId}`);
        if (!response.ok) throw new Error(response.status);

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = doc.querySelectorAll('.nm-rail__item');

        // Ürün gelmediyse başlığı boş bırakmaktansa rayı hiç göstermemek doğru.
        if (items.length === 0) {
          rail.remove();
          return;
        }

        track.replaceChildren(...items);
        this.wireNav(rail, track);
      } catch (error) {
        // Ray yüklenemezse sayfanın geri kalanı çalışmaya devam etsin; ürün ızgarası
        // zaten aşağıda duruyor, iskelet kutuları bırakmak yanıltıcı olurdu.
        rail.remove();
      }
    }

    /*
     * Fareyle tutup çekme.
     *
     * `overflow-x: auto` tek başına yalnızca trackpad, shift+tekerlek ve dokunmatikle
     * kayıyor; masaüstü faresinde ray bozuk görünüyor — kartlar kenarda kesik duruyor
     * ve çekince hiçbir şey olmuyor.
     *
     * **Sürüklerken `scroll-behavior` ve `scroll-snap-type` ikisi birden kapatılmalı.**
     * Her ikisi de atadığın değeri almak yerine ona doğru animasyon yapıyor.
     * NEOMED-CLONE'da karede bir `scrollLeft` yazıp geri okuyarak ölçüldü:
     *
     *     smooth + snap   istenen değerin 187px gerisinde
     *     auto   + snap   135px gerisinde
     *     auto   + none   0px — tam isabet
     *
     * Yalnızca ilkini kapatmak 135px gecikme bırakıyor; "hantal" denen his tam olarak
     * oydu. İkisi de hareket boyunca askıya alınıyor, bırakınca geri geliyor ve
     * tarayıcı en yakın karta kendisi oturuyor.
     */
    wireDrag(track) {
      const ESIK = 6;        // bu kadar pikselden sonrası sürükleme, ve bittiği tıklama sayılmaz
      const SURTUNME = 0.94; // bırakınca süzülmenin kare başına sönümü
      const EN_AZ_HIZ = 0.4; // bunun altında süzülme görünmez, biter ve snap devralır

      let aktif = false;
      let baslangicX = 0;
      let baslangicKaydirma = 0;
      let mesafe = 0;
      let hiz = 0;
      let sonX = 0;
      let sonZaman = 0;
      let suzulme = 0;

      const suzulmeyiDurdur = () => {
        if (suzulme) cancelAnimationFrame(suzulme);
        suzulme = 0;
      };

      /* Kaydırmayı tarayıcıya geri veriyor: snap ve yumuşatma dönüyor. */
      const birak = () => {
        track.style.scrollBehavior = '';
        track.style.scrollSnapType = '';
        track.classList.remove('is-dragging');
      };

      track.addEventListener('pointerdown', (event) => {
        // Dokunmatik ve kalem zaten yerel olarak kayıyor, hem de bundan iyi.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        suzulmeyiDurdur();
        aktif = true;
        baslangicX = event.clientX;
        baslangicKaydirma = track.scrollLeft;
        mesafe = 0;
        hiz = 0;
        sonX = event.clientX;
        sonZaman = event.timeStamp;
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        track.classList.add('is-dragging');
      });

      track.addEventListener('pointermove', (event) => {
        if (!aktif) return;
        const dx = event.clientX - baslangicX;
        mesafe = Math.max(mesafe, Math.abs(dx));
        // Yakalama ancak hareket gerçekten sürüklemeye dönüşünce: karta yapılan düz
        // bir tıklama karta ulaşmaya devam etsin.
        if (mesafe > ESIK) track.setPointerCapture?.(event.pointerId);

        // Mutlak konumdan: ray imleci birebir takip ediyor ve kare başına küçük
        // hatalar birikemiyor.
        track.scrollLeft = baslangicKaydirma - dx;

        const dt = event.timeStamp - sonZaman;
        if (dt > 0) {
          hiz = ((event.clientX - sonX) / dt) * 16.7; // 60Hz'de kare başına piksel
          sonX = event.clientX;
          sonZaman = event.timeStamp;
        }
      });

      track.addEventListener('pointerup', (event) => {
        if (!aktif) return;
        aktif = false;
        track.releasePointerCapture?.(event.pointerId);

        // Fiske atılmışsa ray süzülerek devam ediyor. Snap, süzülme bitene kadar
        // kapalı kalıyor; yoksa sürüklemeyle kavga ettiği gibi onunla da kavga eder.
        if (Math.abs(hiz) > EN_AZ_HIZ) {
          const adim = () => {
            hiz *= SURTUNME;
            if (Math.abs(hiz) < EN_AZ_HIZ) {
              suzulme = 0;
              birak();
              return;
            }
            track.scrollLeft -= hiz;
            suzulme = requestAnimationFrame(adim);
          };
          suzulme = requestAnimationFrame(adim);
          return;
        }
        birak();
      });

      track.addEventListener('pointercancel', () => {
        aktif = false;
        suzulmeyiDurdur();
        birak();
      });

      // Sürüklemeyi bitiren tıklama, imlecin denk geldiği kartı açardı.
      track.addEventListener(
        'click',
        (event) => {
          if (mesafe > ESIK) {
            event.preventDefault();
            event.stopPropagation();
            mesafe = 0;
          }
        },
        true,
      );

      // Kartlar görsel ve bağlantı içeriyor, ikisi de yerel olarak sürüklenebilir;
      // bu olmadan tarayıcı kaydırma yerine hayalet görsel sürüklemeye başlıyor.
      track.addEventListener('dragstart', (event) => event.preventDefault());
    }

    wireNav(rail, track) {
      const buttons = rail.querySelectorAll('.nm-rail__nav');
      const scrollable = track.scrollWidth > track.clientWidth + 1;
      if (!scrollable) return;

      track.classList.add('is-draggable');
      this.wireDrag(track);

      for (const button of buttons) {
        button.hidden = false;
        button.addEventListener('click', () => {
          track.scrollBy({ left: track.clientWidth * Number(button.dataset.dir), behavior: 'smooth' });
        });
      }

      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        buttons[0].disabled = track.scrollLeft <= 0;
        buttons[1].disabled = track.scrollLeft >= max;
      };
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    }
  }

  if (!customElements.get('brand-category-rails')) {
    customElements.define('brand-category-rails', BrandCategoryRails);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-header"] && !Shopify.designMode) return;
  try {
    
  /*
   * Tek bir devredilmiş dinleyici, bölüm başına değil belge başına: Shopify bu bloğu
   * bölüm tipi için bir kez paketliyor, ve düzenleyicide bölüm yeniden çizildiğinde
   * yeniden bağlanmaya gerek kalmıyor.
   *
   * ESC ile kapanma, odak tuzağı ve arka planın etkisizleşmesi `<dialog>`ın kendi
   * işi — burada yalnızca açma, kapatma düğmesi ve karanlık alana tıklama var.
   */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.nm-brand__banner-trigger');
    if (trigger) {
      trigger.closest('.nm-brand')?.querySelector('.nm-brand__lightbox')?.showModal();
      return;
    }

    const closeButton = event.target.closest('.nm-brand__lightbox-close');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    // Hedef diyaloğun kendisiyse tıklama görselin dışına, karanlık alana düşmüştür.
    if (event.target.matches('.nm-brand__lightbox')) event.target.close();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-finder"] && !Shopify.designMode) return;
  try {
    
  /*
   * Soru akışı ve yönlendirme. İkisi de canped.com'daki formdan ölçülerek çıkarıldı;
   * `sonuc()` 19 kombinasyonun hepsinde oradaki sonucu birebir üretiyor.
   */
  /* Hangi sorunun ne zaman sorulacağı. Metinler panelden, koşullar burada:
     ikisini ayırmak, etiketi düzenleyenin akışı bozmasını engelliyor. */
  /* Şık ikonları. Etiketin anlamını taşıyorlar — koşan figür, baston, yatak,
     damla sayısı — o yüzden dekorasyon değil. Ekran okuyucudan gizli, çünkü
     yanındaki metin zaten aynı şeyi söylüyor. */
  const NM_IKON = {
    kendim: { vb: '0 0 24 24', p: '<circle cx="12" cy="8" r="3.2"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0"/>' },
    baskasi: { vb: '0 0 24 24', p: '<circle cx="9" cy="8" r="3"/><path d="M3.5 20a5.5 5.5 0 0 1 11 0"/><path d="M16 5.6a3 3 0 0 1 0 4.8M17 14.4a5.5 5.5 0 0 1 3.5 5.6"/>' },
    aktif: { vb: '0 0 24 24', p: '<circle cx="15.5" cy="4.6" r="1.9"/><path d="M13.5 21l1.4-5.2-3.1-2.6 1-4.6 3.6 2.1 2.6 1M9.5 12.2l1.9-3M6.5 21l3.2-4.3"/>' },
    kisitli: { vb: '0 0 24 24', p: '<circle cx="11" cy="4.6" r="1.9"/><path d="M11 8.4v6m0 0-1.8 6.6m1.8-6.6 1.8 6.6M8 10.4h6M17 11.5V21"/>' },
    yatar: { vb: '0 0 24 24', p: '<path d="M3 19v-6h18v6M3 19v1.6M21 19v1.6M3 13V7.5M7 13v-2.2h6V13"/><circle cx="6" cy="9.6" r="1.7"/>' },
    erkek: { vb: '0 0 24 24', p: '<circle cx="10" cy="14" r="4.6"/><path d="M13.4 10.6 20 4m0 0h-4.6M20 4v4.6"/>' },
    kadin: { vb: '0 0 24 24', p: '<circle cx="12" cy="9" r="4.6"/><path d="M12 13.6V21m-3 -3.2h6"/>' },
    hafif: { vb: '0 0 16 24', p: '<path fill="currentColor" stroke="none" d="M8 4c3.4 4.2 5.2 7 5.2 8.9a5.2 5.2 0 0 1-10.4 0c0-1.9 1.8-4.7 5.2-8.9Z"/>' },
    orta: { vb: '0 0 30 24', p: '<path fill="currentColor" stroke="none" d="M8 4c3.4 4.2 5.2 7 5.2 8.9a5.2 5.2 0 0 1-10.4 0c0-1.9 1.8-4.7 5.2-8.9Z"/><path fill="currentColor" stroke="none" d="M22 4c3.4 4.2 5.2 7 5.2 8.9a5.2 5.2 0 0 1-10.4 0c0-1.9 1.8-4.7 5.2-8.9Z"/>' },
    yogun: { vb: '0 0 44 24', p: '<path fill="currentColor" stroke="none" d="M8 4c3.4 4.2 5.2 7 5.2 8.9a5.2 5.2 0 0 1-10.4 0c0-1.9 1.8-4.7 5.2-8.9Z"/><path fill="currentColor" stroke="none" d="M22 4c3.4 4.2 5.2 7 5.2 8.9a5.2 5.2 0 0 1-10.4 0c0-1.9 1.8-4.7 5.2-8.9Z"/><path fill="currentColor" stroke="none" d="M36 4c3.4 4.2 5.2 7 5.2 8.9a5.2 5.2 0 0 1-10.4 0c0-1.9 1.8-4.7 5.2-8.9Z"/>' },
  };

  const NM_KOSUL = {
    kim: null,
    // Canped hareket durumunu yalnızca "başkası için" yolunda soruyor. Bunun sonucu,
    // kendisi için bakan yatalak birinin belbantlı bez önerisi alamaması — emici
    // külot alıyor, ki yanlış. Soru her iki yolda da soruluyor.
    hareket: null,
    yas: (c) => c.kim === 'baskasi',
    cinsiyet: (c) => c.kim === 'kendim',
    hamile: (c) => c.cinsiyet === 'kadin',
    // Canped'in mantığı: erkekse, hamile değilse, ya da bakılan kişi 14 yaş üstüyse.
    // Ek olarak: yatalakta seviye sorulmuyor. Canped soruyor ama üç cevabı da aynı
    // sonuca çıkıyor — ölçüldü. Cevabı değiştirmeyen soruyu sormamak daha dürüst.
    seviye: (c) =>
      c.hareket !== 'yatar' &&
      (c.cinsiyet === 'erkek' || c.hamile === 'hayir' || c.yas === 'buyuk'),
  };

  /* Ana öneri — asıl ürün, tek başına.
     Yatak koruyucu örtü ve temizleme havlusu bir zamanlar buraya da ekleniyordu;
     `nmYaninda`ya taşındılar ve artık her sonuçta çıkmıyorlar. */
  function nmSonuc(c) {
    // Çocuk her şeyin önünde: yetişkin ürünü önerilmemeli.
    if (c.kim === 'baskasi' && c.yas === 'kucuk') {
      return [c.hareket === 'yatar' ? 'cocuk-belbantli' : 'cocuk-kulot'];
    }

    // Yatalak yetişkin: her iki yolda da belbantlı. Canped bunu yalnızca "başkası
    // için" yolunda verebiliyordu, çünkü hareket durumunu orada soruyordu.
    if (c.hareket === 'yatar') return ['bel-bantli'];

    if (c.kim === 'kendim') {
      if (c.cinsiyet === 'erkek') {
        return [c.seviye === 'hafif' ? 'erkek-mesane' : 'emici-kulot'];
      }
      // Hamilelikte seviye sorulmuyor; hem ped hem külot öneriliyor.
      if (c.hamile === 'evet') return ['kadin-mesane', 'emici-kulot'];
      return [c.seviye === 'hafif' ? 'kadin-mesane' : 'emici-kulot'];
    }

    if (c.seviye === 'hafif') {
      return c.hareket === 'kisitli' ? ['mesane', 'emici-kulot'] : ['mesane'];
    }
    return ['emici-kulot'];
  }

  /* Bez ve külot grubu: kullanıldığı sürece temizlik işi çıkaran ürünler. Mesane
     pedleri bu listede yok — hafif kaçırmada pedi değiştirmek dışında bir iş yok. */
  const NM_BEZ = ['emici-kulot', 'bel-bantli', 'cocuk-kulot', 'cocuk-belbantli'];

  /*
   * "Yanında işinize yarar" — koşullu.
   *
   * Bu ikili eskiden sabitti: 19 yolun 19'unda da ekleniyordu ve sonuçtaki üç
   * karttan ikisi her testte aynı çıkıyordu. Artık ikisinin de kendi kuralı var.
   *
   * **Yatak koruyucu örtü** yalnızca yatalak kişide — yatağa sızıntı riski orada
   * gerçek. Ve emici külotla asla birlikte değil: bugün yapısal olarak da denk
   * gelmiyor (yatalak yolunda ana öneri belbantlı), ama koşul açıkça yazılı ki
   * `nmSonuc` ileride değişirse kural kendiliğinden ayakta kalsın.
   *
   * **Vücut temizleme havlusu** bez ya da külot önerilen her sonuçta — emici
   * külotun arkasından kesinlikle. Ürünün kendisi temizlik gerektiriyor;
   * havlusuz bir emici külot önerisi eksik bir öneri. Bakım verende de her
   * hâlükârda var, temizliği yapan o.
   *
   * Geriye tek kartlı iki yol kalıyor: kendisi için bakan, hafif kaçıran kadın ve
   * erkek. Orada ped tek başına doğru cevap — yanına bir şey koymak öneri değil
   * satış olurdu.
   */
  function nmYaninda(c, ana) {
    const liste = [];
    if (c.hareket === 'yatar' && !ana.includes('emici-kulot')) liste.push('yatak');
    if (c.kim === 'baskasi' || ana.some((k) => NM_BEZ.includes(k))) liste.push('havlu');
    return liste;
  }

  class ProductFinder extends HTMLElement {
    connectedCallback() {
      const kat = this.querySelector('[data-finder-categories]');
      const sor = this.querySelector('[data-finder-questions]');
      this.kategoriler = kat ? JSON.parse(kat.textContent) : {};
      // Metni boş bırakılmış soru hiç sorulmuyor: panelden bir soruyu kaldırmanın
      // yolu, kodu değiştirmek değil metnini silmek olsun.
      this.sorular = (sor ? JSON.parse(sor.textContent) : []).filter((q) => q.soru);
      this.stage = this.querySelector('[data-finder-stage]');
      this.marka = this.dataset.brand;
      this.cevaplar = this.dataset.mode === 'modal' ? {} : this.adrestenOku();
      this.adim = 0;
      this.sheet = this.querySelector('.nm-pf__sheet');

      if (this.sheet) {
        // Afiş gerçek bir bağlantı olarak kalıyor; JS varsa tıklama burada yakalanıp
        // katman açılıyor, yoksa ziyaretçi test sayfasına gidiyor. Kaybolan bir yol yok.
        document.addEventListener('click', (event) => {
          const tetik = event.target.closest('[data-open-finder]');
          if (!tetik) return;
          event.preventDefault();
          this.cevaplar = {};
          this.adim = 0;
          this.ciz();
          this.sheet.showModal();
        });
        this.querySelector('[data-pf-close]')?.addEventListener('click', () => this.sheet.close());
        this.sheet.addEventListener('click', (event) => {
          if (event.target === this.sheet) this.sheet.close();
        });
        return; // Katman açılana kadar çizmeye gerek yok.
      }

      this.ciz();
    }

    /* Sonuç adresi paylaşılabilsin diye cevaplar adreste taşınıyor. */
    adrestenOku() {
      const c = {};
      for (const [k, v] of new URLSearchParams(location.hash.slice(1))) c[k] = v;
      return c;
    }

    /* Sayfa modunda cevaplar adreste taşınıyor: bir test sonucu bağlantı olarak
       paylaşılabiliyor. Katman modunda adres çubuğuna dokunulmuyor — ziyaretçi
       marka sayfasında, oranın adresi onun. */
    adreseYaz() {
      if (this.dataset.mode === 'modal') return;
      const p = new URLSearchParams(this.cevaplar);
      history.replaceState(null, '', `${location.pathname}#${p}`);
    }

    /* Cevaplara göre sorulacak soruların listesi; her cevapta yeniden hesaplanıyor. */
    get akis() {
      return this.sorular.filter((q) => !NM_KOSUL[q.id] || NM_KOSUL[q.id](this.cevaplar));
    }

    ciz() {
      const akis = this.akis;
      if (this.adim >= akis.length) return this.cizSonuc(akis);

      const soru = akis[this.adim];
      const secili = this.cevaplar[soru.id];

      this.stage.replaceChildren();
      this.stage.insertAdjacentHTML(
        'beforeend',
        `${this.iz(akis)}
        <h2 class="nm-pf__q">${soru.soru}</h2>
        <div class="nm-pf__options" role="group" aria-label="${soru.soru.replace(/"/g, '&quot;')}">
          ${soru.siklar
            .map(
              (o) =>
                `<button type="button" class="nm-pf__chip" aria-pressed="${o.d === secili}" data-sik="${o.d}">${
                  NM_IKON[o.d]
                    ? `<svg viewBox="${NM_IKON[o.d].vb}" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${NM_IKON[o.d].p}</svg>`
                    : ''
                }<span>${o.e}</span></button>`,
            )
            .join('')}
        </div>
        <button type="button" class="nm-pf__go" data-ileri ${secili ? '' : 'disabled'}>
          ${this.dataset.labelNext}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>`,
      );

      for (const b of this.stage.querySelectorAll('[data-sik]')) {
        b.addEventListener('click', () => {
          // Sonraki soruların koşulu değiştiği için bu cevabın altındakiler siliniyor;
          // yoksa "Kadın → hamile: Evet" seçip "Erkek"e dönen biri hamilelik cevabını
          // yanında taşır ve sonuç yanlış çıkar.
          const ids = this.akis.map((q) => q.id);
          for (const id of ids.slice(ids.indexOf(soru.id) + 1)) delete this.cevaplar[id];
          this.cevaplar[soru.id] = b.dataset.sik;
          this.adreseYaz();
          this.ciz();
        });
      }

      this.stage.querySelector('[data-ileri]')?.addEventListener('click', () => {
        this.adim++;
        this.ciz();
      });
      this.iziBagla();
    }

    /* Cevap izi: verilen cevaplar chip olarak birikiyor, birine dokununca o soruya
       dönülüyor. İlerleme çubuğu ile geri tuşunun ikisinin de yerine geçiyor ve
       ekranda gerçekten bir bilgi taşıyor — "3. adımdasınız" taşımıyordu. */
    iz(akis) {
      const verilen = akis.slice(0, this.adim).filter((q) => this.cevaplar[q.id]);
      if (verilen.length === 0) {
        return `<div class="nm-pf__trail"><span class="nm-pf__eyebrow">${this.dataset.eyebrow}</span></div>`;
      }
      return `<div class="nm-pf__trail">${verilen
        .map((q, i) => {
          const etiket = q.siklar.find((o) => o.d === this.cevaplar[q.id])?.e ?? '';
          return `${i ? '<span class="nm-pf__sep" aria-hidden="true">›</span>' : ''}<button type="button" class="nm-pf__crumb" data-geri-adim="${i}">${etiket}</button>`;
        })
        .join('')}</div>`;
    }

    /* Öneri kartı. `etiket` verilirse kartın üstünde küçük bir başlık çıkıyor:
       yanında önerilenler ayrı bir bölüme alınmıyor artık, hepsi tek ızgarada —
       ama hangisinin asıl öneri olmadığı okunabilir kalıyor. */
    kart(k, etiket) {
      const kat = this.kategoriler[k];
      const url = kat.url
        ? `${kat.url}?filter.p.m.custom.marka=${encodeURIComponent(this.marka)}`
        : '#';
      return `<article class="nm-pf__card">
        ${
          kat.gorsel
            ? `<img class="nm-pf__thumb" src="${kat.gorsel}" alt="" loading="lazy" width="88" height="88">`
            : '<span class="nm-pf__thumb"></span>'
        }
        <div class="nm-pf__card-body">
          ${etiket ? `<span class="nm-pf__tag">${etiket}</span>` : ''}
          <h3 class="nm-pf__card-title">${kat.baslik}</h3>
          ${kat.aciklama ? `<p class="nm-pf__card-text">${kat.aciklama}</p>` : ''}
          <a class="nm-pf__buy" href="${url}">
            ${this.dataset.labelCta}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 4h6v6M20 4l-8.5 8.5M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4"/></svg>
          </a>
        </div>
      </article>`;
    }

    /* Izgaranın son karesi: önerilen kategorinin blog yazısı — "ne öneriyorsak
       onun yazısı". Sıra ana öneriden başlıyor, yanındakiler sonra; ilk yazısı
       olan kategori kazanıyor.

       Hiçbir önerilen kategoriye yazı bağlanmamışsa kare hiç açılmıyor: boş bir
       kutu, dolu üç kartın yanında eksik iş gibi duruyor. Yazı bağlama yeri
       panelde her "Sonuç kategorisi" bloğundaki "İlgili blog yazısı". */
    yaziKarti(anahtarlar) {
      const k = anahtarlar.find((x) => this.kategoriler[x]?.yaziUrl);
      if (!k) return '';
      const y = this.kategoriler[k];
      return `<article class="nm-pf__card nm-pf__card--yazi">
        ${
          y.yaziGorsel
            ? `<img class="nm-pf__thumb" src="${y.yaziGorsel}" alt="" loading="lazy" width="88" height="88">`
            : `<span class="nm-pf__thumb nm-pf__thumb--bos">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 19.5V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v13.5M4 19.5A1.5 1.5 0 0 0 5.5 21H20M4 19.5A1.5 1.5 0 0 1 5.5 18H20v3M8 8h8M8 12h6" stroke-linecap="round" stroke-linejoin="round"/></svg>
               </span>`
        }
        <div class="nm-pf__card-body">
          <span class="nm-pf__tag">${this.dataset.readsTitle}</span>
          <h3 class="nm-pf__card-title">${y.yaziBaslik || ''}</h3>
          ${y.yaziOzet ? `<p class="nm-pf__card-text">${y.yaziOzet}</p>` : ''}
          <a class="nm-pf__buy nm-pf__buy--ghost" href="${y.yaziUrl}">
            ${this.dataset.labelRead}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>
          </a>
        </div>
      </article>`;
    }

    iziBagla() {
      for (const b of this.stage.querySelectorAll('[data-geri-adim]')) {
        b.addEventListener('click', () => {
          this.adim = Number(b.dataset.geriAdim);
          this.ciz();
        });
      }
    }

    cizSonuc(akis) {
      // Hepsi tek ızgarada: önce ana öneri, sonra yanındakiler, en son blog karesi.
      // Ayrı bölümlerdeyken tek öneri çıkan yollarda ekran üç ayrı başlıkla üç kez
      // bölünüyordu; ızgara, sıradaki kareyi doldurarak aynı işi başlıksız yapıyor.
      //
      // `stokta` süzgeci: markanın o kategoride satın alınabilir ürünü yoksa kart
      // hiç basılmıyor. Öneri, alınamayan bir ürünü göstermemeli — ölçüm ve gerekçe
      // için yukarıdaki Liquid yorumuna bak.
      const satilir = (k) => this.kategoriler[k]?.stokta;
      const ana = nmSonuc(this.cevaplar).filter(satilir);
      const yaninda = nmYaninda(this.cevaplar, ana).filter(satilir);
      const anahtarlar = [...ana, ...yaninda];

      // Hiçbir öneri stokta değilse ızgara boş kalırdı. Boş ızgara, testin
      // çalışmadığı izlenimi veriyor; onun yerine ne olduğu söyleniyor ve markanın
      // tüm ürünlerine bir kapı açılıyor. Yazı, önerilenin yazısı olarak kalıyor:
      // stok yok diye konu ilgisizleşmiyor.
      const bos = ana.length === 0;
      const yaziIcin = bos ? nmSonuc(this.cevaplar) : anahtarlar;

      this.stage.replaceChildren();
      this.stage.insertAdjacentHTML(
        'beforeend',
        `${this.iz(akis)}
         <h2 class="nm-pf__q">${bos ? this.dataset.emptyHeading : this.dataset.resultHeading}</h2>
         ${
           bos
             ? `<p class="nm-pf__empty">${this.dataset.emptyText}</p>
                <div class="nm-pf__cards">
                  ${yaninda.map((k) => this.kart(k, this.dataset.asideTitle)).join('')}
                  ${this.yaziKarti(yaziIcin)}
                </div>
                <a class="nm-pf__buy nm-pf__buy--wide" href="${this.dataset.brandUrl}">
                  ${this.dataset.emptyCta}
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>
                </a>`
             : `<div class="nm-pf__cards">
                  ${ana.map((k) => this.kart(k)).join('')}
                  ${yaninda.map((k) => this.kart(k, this.dataset.asideTitle)).join('')}
                  ${this.yaziKarti(yaziIcin)}
                </div>`
         }
         <button type="button" class="nm-pf__restart" data-bastan>${this.dataset.labelRestart}</button>`,
      );

      this.iziBagla();
      this.stage.querySelector('[data-bastan]')?.addEventListener('click', () => {
        this.cevaplar = {};
        this.adim = 0;
        this.adreseYaz();
        this.ciz();
      });
    }
  }

  if (!customElements.get('product-finder')) customElements.define('product-finder', ProductFinder);

  } catch(e) { console.error(e); }
})();
})();
